import React from 'react';
import { Navigate } from 'react-router';
import Base from './Base';
import { Header } from './Header';
import { Footer } from './Footer';
import Document from "./Document";
import { NavLink } from 'react-router-dom';
import DatePicker from 'react-datepicker2';
import momentJalaali from 'moment-jalaali';

export default class ExploreReport extends Base {
    constructor(props) {
        super(props);
        this.state = {
            id: props.Id,
            data: null,
            loading: true,
            fromDate: this.getQueryString("from",null),
            toDate: this.getQueryString("to", null),
            configName: 'explore_report',
            isReverse: props.IsReverse
        }
        if (!this.isBlank(this.state.fromDate)) this.state.fromDate = momentJalaali(this.getQueryString("from", null));
        if (!this.isBlank(this.state.toDate)) this.state.toDate = momentJalaali(this.getQueryString("to", null));
    }
    componentDidMount() {
        this.getData();
    }
    componentWillReceiveProps(props) {
        this.state.id = props.Id;
        this.getData();
    }
    getData() {
        this.httpPost("api/v1/report/explore", {
            isReverse: this.state.isReverse,
            id: this.getCurrentFormId(),
            fromDate: this.convertMomentToDb(this.state.fromDate),
            toDate: this.convertMomentToDb(this.state.toDate),
        })
        .then(data => {
            if (data.status === -1) window.location.href = "/login";
            if (data.status === 1) {
                if (this.state.fromDate == null) {
                    this.state.fromDate = data.global.annual.from;
                    this.state.toDate = data.global.annual.to;
                }
                this.setState({
                    data: data,
                    loading: false
                })
            }
            else {
                this.showErorrMessage(data.message);
                this.setState({
                    loading: false
                });
            }
        });
    }
    getDateLinkAppend() {
        if (this.state.fromDate == null) return "";
        return "?from=" + this.convertMomentToDb2(this.state.fromDate) + "&to=" + this.convertMomentToDb2(this.state.toDate);
    }
    showDocument(id) {
        this.showComponents({ component: <Document Caller={this} Id={id} /> });
    }
    getDefaultConfig() {
        return {
            name: this.state.configName,
            fields: [
                { field: "fullCode", caption: "کدحساب", show: true },
                { field: "title", caption: "نام حساب", show: true },
                { field: "bed", caption: "گردش بدهکار", show: true },
                { field: "bes", caption: "گردش بستانکار", show: true },
                { field: "remainBed", caption: "مانده بدهکار", show: true },
                { field: "remainBes", caption: "مانده بستانکار", show: true },
            ]
        }
    }
    getColumns() {
        var config = this.getGridConfig();
        var t = [];
        config.fields.forEach(f => {
            if (f.field == 'fullCode' && f.show) t.push({
                field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => {
                    if (!this.state.isReverse) {
                        if (props.data.accountType > 3)
                            return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/" + props.data.id + this.getDateLinkAppend() + "&mcode=" + this.state.data.moein.fullCode}>{props.data.fullCode}</NavLink>

                        return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + props.data.accountType + "/" + props.data.id + this.getDateLinkAppend()}>{props.data.fullCode}</NavLink>
                    }
                    else {
                        if (props.data.accountType > 1)
                            return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + (props.data.accountType - 1) + "u/" + props.data.id + this.getDateLinkAppend()}>{props.data.fullCode}</NavLink>
                        else
                            return props.data.fullCode;
                    }
                }
            });
            if (f.field == 'title' && f.show) t.push({
                field: f.field, headerName: f.caption, cellRenderer: (props) => {
                    if (!this.state.isReverse) {
                        if (props.data.accountType > 3)
                            return <NavLink className="text-primary txt-bold hand" to={"/report/transactions/" + props.data.id + this.getDateLinkAppend() + "&mcode=" + this.state.data.moein.fullCode}>{props.data.title}</NavLink>

                        return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + props.data.accountType + "/" + props.data.id + this.getDateLinkAppend()}>{props.data.title}</NavLink>
                    }
                    else {
                        if (props.data.accountType > 1)
                            return <NavLink className="text-primary txt-bold hand" to={"/report/explore" + (props.data.accountType - 1) + "u/" + props.data.id + this.getDateLinkAppend()}>{props.data.title}</NavLink>
                        else
                            return props.data.title;
                    }
                }
            });
            if (f.field == 'bed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
            if (f.field == 'bes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
            if (f.field == 'remainBed' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remainBed) } });
            if (f.field == 'remainBes' && f.show) t.push({ field: f.field, headerName: f.caption, cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.remainBes) } });
        });
        return t;
    }
    getTrxColumns() {
        var t = [];
        t.push({ field: "date", headerName: "تاریخ" });
        t.push({ field: "description", headerName: "شرح سند" });
        t.push({ field: "number2", headerName: "شماره عطف" });
        t.push({ field: "number", headerName: "شماره سند" });
        t.push({ field: "bed", headerName: "بدهکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bed) } });
        t.push({ field: "bes", headerName: "بستانکار", cellDataType: 'number', cellRenderer: (props) => { return this.money(props.data.bes) } });
        return t;
    }
    renderFilters() {
        var res = [];

        if (!this.isNull(this.state.data.group)) {
            if (!this.state.isReverse)
                res.push(<NavLink to="/report/explore/" className="hand badge rounded-pill bg-danger me-1">مرورحسابها از کل به جز</NavLink>);
            else
                res.push(<NavLink to="/report/explore/" className="hand badge rounded-pill bg-danger me-1">مرورحسابها از جز به کل</NavLink>);
        }

        if (!this.state.isReverse) {
            if (!this.isNull(this.state.data.group))
                res.push(<NavLink to={"/report/explore1/" + this.state.data.group.id} className="badge rounded-pill bg-info mr-2">{this.state.data.group.title}</NavLink>);
            if (!this.isNull(this.state.data.kol))
                res.push(<NavLink to={"/report/explore2/" + this.state.data.kol.id} className="badge rounded-pill bg-info mr-2">{this.state.data.kol.title}</NavLink>);
            if (!this.isNull(this.state.data.moein))
                res.push(<NavLink to={"/report/explore3/" + this.state.data.moein.id} className="badge rounded-pill bg-info mr-2">{this.state.data.moein.title}</NavLink>);
        }
        else {
            if (!this.isNull(this.state.data.kol))
                res.push(<NavLink to={"/report/explore1/" + this.state.data.kol.id} className="badge rounded-pill bg-info mr-2">از جز  {this.state.data.kol.title}</NavLink>);
            if (!this.isNull(this.state.data.moein))
                res.push(<NavLink to={"/report/explore2/" + this.state.data.moein.id} className="badge rounded-pill bg-info mr-2">از جز  {this.state.data.moein.title}</NavLink>);
            if (!this.isNull(this.state.data.tafsil))
                res.push(<NavLink to={"/report/transactions/" + this.state.data.tafsil.id} className="badge rounded-pill bg-info mr-2">از جز  {this.state.data.tafsil.title}</NavLink>);
        }
        return res;
    }
    renderForm() {
        return <div className="container">
            <div className="row">
                <div className="col-sm-12">
                    <div className="panel panel-info">
                        <div className="panel-body">
                            <div className="col-sm-3">
                                {!this.state.isReverse ? "مرور حسابها از کل به جز" : "مرور حسابها از جز به کل"}
                            </div>
                            <div className="col-sm-6 text-center" style={{ "display": "flex", "place-content": "center" }}>
                                از
                                <DatePicker
                                    inputReadOnly={true}
                                    className="range-from-example text-center mr-l-5 mr-r-5"
                                    placeholder={"از تاریخ"}
                                    isGregorian={false}
                                    showTodayButton={true}
                                    timePicker={false}
                                    onChange={(e) => { this.state.fromDate = e }}
                                    value={this.getFormatedDateForDatePicker(this.state.fromDate)}
                                />
                                تا
                                <DatePicker
                                    inputReadOnly={true}
                                    className="range-to-example text-center mr-r-5"
                                    placeholder={"تا تاریخ"}
                                    isGregorian={false}
                                    showTodayButton={true}
                                    timePicker={false}
                                    onChange={(e) => { this.state.toDate = e }}
                                    value={this.getFormatedDateForDatePicker(this.state.toDate)}
                                />
                                <a className="hand mr-r-5" onClick={e => this.getData()}><i className="fa fa-search"></i></a>
                            </div>
                            <div className="col-sm-3 text-left">
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPrint('مرور حسابها')} title="چاپ">
                                    <span className="fa fa-print"></span>
                                </button>
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onPdf('مرور حسابها')} title="PDF">
                                    <span className="fa fa-file-pdf-o"></span>
                                </button>
                                <button className="btn btn-no-frame btn-smoke hand" onClick={e => this.onExcel('مرور حسابها')} title="اکسل">
                                    <span className="fa fa-file-excel-o"></span>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div>
                {this.renderFilters()}
            </div>
            {this.renderAgGrid({
                columnDefs: this.getColumns(),
            })}
        </div>
    }
    setAgGridSelectedRow(e) {
        var t = [];
        e.forEach(ee => t.push(ee.id));
        this.state.selectedIds = t;
    }
    render() {
        if (!this.isBlank(this.state.redirect)) return <Navigate to={this.state.redirect} />

        let contents = this.state.loading ? this.renderLoading() :
            [
                this.state.lockScreen === 1 && this.lockScreen(),
                <Header data={this.state.data} />,
                this.getGlobalContainer(),
                this.renderForm(),
                this.renderPopupComponent(),
                <Footer />
            ];

        return contents;
    }
}